enum HeadingStyle {
  PAGE_TITLE = 'PAGE_TITLE', // "H1" in the styleguide.
  PAGE_SUBTITLE = 'PAGE_SUBTITLE', // "H2" in the styleguide.
  CONTAINER_TITLE = 'CONTAINER_TITLE', // "H3" in the styleguide
  CONTAINER_SUBTITLE = 'CONTAINER_SUBTITLE', // "H4" in the styleguide
}

export default HeadingStyle;
